import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo, useState } from 'react';
import { AutoIgnitionState } from 'console/device/types';
import { useAnchor } from 'shared/hooks/utils';
import { TimedRenderer } from 'console/react-elements/timed-renderer';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { currentServerUnixTime, duration } from 'webui/utils/time';
import { VehicleDeviceState } from 'console/shared/contexts/vehicle-device/state/types';
import { VehicleControlButton } from './index';
import { show_toast } from 'console/dialogs/toast';
import { useVehicleControl } from '../provider';
import { AutoStartMenu } from 'shared/components/panels/vehicle-panel/components/controls/button/menu';
export function getAutoStartIndicator(auto_ignition, time_active, server_time) {
    const { state, until } = auto_ignition;
    if (state === AutoIgnitionState.enabling) {
        return 'Запуск';
    }
    if (time_active && until) {
        const left = until - currentServerUnixTime(server_time);
        return duration(Math.max(0, left), {
            seconds: true,
            zeros: false,
        });
    }
    return;
}
export const AutoStartButton = memo(function AutoStartButton() {
    const { active, duration } = useVehicleControl();
    const [anchor, openMenu, closeMenu] = useAnchor();
    const { auto_ignition } = useContext(VehicleDeviceState);
    const server_time = useAppSelector((state) => state.server_time);
    const [showed_menu_count, setShowedMenuCount] = useState(0);
    const time_active = useMemo(() => {
        if (auto_ignition) {
            const { state, until } = auto_ignition;
            return ([
                AutoIgnitionState.enabled,
                AutoIgnitionState.webasto,
                AutoIgnitionState['webasto-confirmed'],
            ].includes(state) && until != null);
        }
        return false;
    }, [auto_ignition?.state, auto_ignition?.until]);
    const onShowToast = useAction(show_toast);
    const onDisabledAutoIgnitionClick = useCallback(() => onShowToast('Не выполнена резервация автозапуска'), [onShowToast]);
    const disabled_autostart = useMemo(() => auto_ignition &&
        !auto_ignition.available &&
        !auto_ignition.configuration.webasto, [auto_ignition]);
    const timer = useMemo(() => (_jsx(TimedRenderer, { active: time_active, interval: 1e3, children: () => {
            const autostart_indicator = auto_ignition &&
                getAutoStartIndicator(auto_ignition, time_active, server_time);
            if (!autostart_indicator) {
                return null;
            }
            return autostart_indicator;
        } })), [time_active, auto_ignition, server_time]);
    return (_jsx(VehicleControlButton, { disabled: disabled_autostart, onDisabledClick: onDisabledAutoIgnitionClick, label: active ? timer : undefined, openMenu: openMenu, showed_menu_count: showed_menu_count, menu: _jsx(AutoStartMenu, { onClose: closeMenu, anchor: anchor, auto_ignition: auto_ignition, auto_ignition_duration: duration, setMenuItemCount: setShowedMenuCount }) }));
});
